import React, { FC } from 'react';
import History from 'src/components/History';
import { getCodesObject } from 'src/resources/constantsCodes/functions';
import { ConstantsCodesObjectType } from 'src/types/constantsCodes';
import { TransportChangelogType } from 'src/types/transportDetail';
import getCountryOptions from 'src/utils/countryOptions';
import { historyUpdates, historyPackagesUpdates, historyUpdatesSkladonUser } from './constants';

export interface HistoryPropsType {
    changelog: TransportChangelogType | null;
    transportStatusCodesObject: ConstantsCodesObjectType;
    paymentCodesObject: ConstantsCodesObjectType;
    shipperCodesObject: ConstantsCodesObjectType;
    serviceCodesObject: ConstantsCodesObjectType;
    lineStateCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
    transportTypeCodesObject: ConstantsCodesObjectType;
    skladonUser?: number;
}

const HistoryBlock: FC<HistoryPropsType> = (props) => {
    const countryCodesObject = getCodesObject(getCountryOptions());
    return (
        <History
            updates={props.changelog?.updates}
            updateKeys={props.skladonUser ? historyUpdatesSkladonUser : historyUpdates}
            updateItemsKeys={{
                PACKAGES: { itemKeys: historyPackagesUpdates },
            }}
            keyCodes={{
                STATUS: props.transportStatusCodesObject,
                PAYMENT_METHOD: props.paymentCodesObject,
                SHIPPER: props.shipperCodesObject,
                SHIPPER_SERVICE_CODE: props.serviceCodesObject,
                PAID: props.boolNumberCodesObject,
                TRANSPORT_PAID_BY_SKLADON: props.boolNumberCodesObject,
                SHIPMENT_PENDING: props.boolNumberCodesObject,
                AGECHECK: props.boolNumberCodesObject,
                TYPE: props.transportTypeCodesObject,
                SENDER_STATE: countryCodesObject,
                RECIPIENT_STATE: countryCodesObject,
            }}
            keyItemsCodes={{
                PACKAGES: {
                    LINE_STATE: props.lineStateCodesObject,
                    STATUS: props.transportStatusCodesObject,
                },
            }}
            translatePrefix="transportDetail"
        />
    );
};

export default HistoryBlock;
